<template>
	<div>
		<v-text-field :label="label" @click="$refs.fileInput.click()" v-model="fileName" prepend-icon="far fa-paperclip" :append-outer-icon="viewIcon" @click:append-outer="view"></v-text-field>
		<input
			type="file"
			style="display: none"
			ref="fileInput"
			:accept="accept"
			@change="filePicked($event, 'holter-report-config', 'holterReportConfigName')"
		>
	</div>
</template>

<script>
export default {
	props: {
		type: String,
		name: String,
		label: String,
		viewable: {
			type: Boolean,
			default: false,
		},
		url: String,
	},
	data() {
		return {
			fileName: null,
		};
	},
	computed: {
		accept() {
			return this.type === "image" ? "image/*" : "*";
		},
		viewIcon() {
			if (!this.viewable) {
				return null;
			}
			return this.url ? "far fa-eye primary--text clickable" : "far fa-eye grey--text not-clickable";
		},
	},
	methods: {
		view() {
			if (!this.url || !this.viewable) {
				return;
			}
			window.open(this.url, "configpreview");
		},
		getExtension(filename) {
			return filename.lastIndexOf(".") <= 0 ? "" : filename.split(".").pop();
		},
		arrayBufferToBase64(buffer) {
			let binary = "";
			const bytes = new Uint8Array(buffer);
			const len = bytes.byteLength;
			for (let i = 0; i < len; i += 1) {
				binary += String.fromCharCode(bytes[i]);
			}
			return window.btoa(binary);
		},
		filePicked(e) {
			const files = e.target.files;

			this.fileName = null;
			this.$emit("clear", this.name);

			if (files[0] === undefined) {
				return;
			}

			this.fileName = files[0].name;
			const ext = this.getExtension(files[0].name);
			if (ext === "") {
				return;
			}
			const fr = new FileReader();
			fr.onload = () => {
				const data = this.type === "image" ? this.arrayBufferToBase64(fr.result) : fr.result;
				this.$emit("change", {
					fileName: `${this.name}.${ext}`,
					fileContents: data,
				});
			};
			if (this.type === "image") {
				fr.readAsArrayBuffer(files[0]);
			} else {
				fr.readAsText(files[0]);
			}
		},
		clear() {
			this.fileName = null;
		},
	},
};
</script>
